<template>
  <div class="dropdown-parent-container">
    <button
      type="button"
      title="Help"
      class="sc3-button sc3-button-fixed-height sc3-button-grey icon-large"
      :class="{
        'sc3-button-active': isOpen
      }"
      ref="helpDropdownMenuToggleButtonNode"
      @click="toggleDropdown()"
    ><i class="fas fa-fw fa-question-circle"></i></button>
    <DropdownMenu
      :nodes-excluded-from-closing-on-outside-click="helpDropdownMenuToggleButtonNode ? [helpDropdownMenuToggleButtonNode] : []"
      :dropdown-button-left-value="left"
      v-model:is-open="isOpen"
      v-model:max-body-height="dropdownHeight"
      :dropdown-menu-toggle-button-node="helpDropdownMenuToggleButtonNode"
    >
      <template v-slot:body>
        <ul>
          <template v-if="shouldShowInteractiveTour">
            <li>
              <button
                type="button"
                @click="[closeDropdown(), launchStartInteractiveTourModal()]"
              >
                <i class="fas fa-fw fa-directions"></i>
                &nbsp;Take a Tour of the Workbench
              </button>
            </li>
            <li class="dropdown-divider"></li>
          </template>
          <li>
            <a
              href="//help.stockcharts.com/charts-and-tools/sharpcharts"
              target="_blank"
              rel="noopener noreferrer"
              @click="closeDropdown()"
            >
              <i class="fas fa-fw fa-info-circle"></i>
              &nbsp;Documentation
            </a>
          </li>
          <li class="dropdown-divider"></li>
          <li>
            <a
              href="//help.stockcharts.com"
              target="_blank"
              rel="noopener noreferrer"
              @click="closeDropdown()"
            >
              <i class="fas fa-fw fa-life-ring"></i>
              &nbsp;Support Center
            </a>
          </li>
          <li>
            <a
              href="/support/techsupport.html"
              target="_blank"
              @click="closeDropdown()"
            >
              <i class="far fa-fw fa-envelope"></i>
              &nbsp;Contact Us
            </a>
          </li>
          <li>
            <a
              href="/support/techsupport.html"
              target="_blank"
              @click="closeDropdown()"
            >
              <i class="fas fa-fw fa-bug"></i>
              &nbsp;Report An Issue
            </a>
          </li>
          <li>
            <a
              href="/support/feedback/"
              target="_blank"
              @click="closeDropdown()"
            >
              <i class="far fa-fw fa-comment-alt-smile"></i>
              &nbsp;Share Feedback
            </a>
          </li>
        </ul>
      </template>
    </DropdownMenu>
  </div>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue';
  import { useBoundingClientRect } from '@/composables/useBoundingClientRect';
  import { useModals } from '@/composables/useModals';
  import { useScreenSizing } from '@/composables/useScreenSizing';
  import DropdownMenu from '@/components/dropdowns/DropdownMenu.vue';

  const { getBoundingClientRectPropertyRefs } = useBoundingClientRect();
  const { launchStartInteractiveTourModal } = useModals();
  const { shouldShowInteractiveTour } = useScreenSizing();
  const helpDropdownMenuToggleButtonNode = ref<HTMLButtonElement>();
  const isOpen = ref<boolean>(false);
  const dropdownHeight = ref<number>(0);
  const { left } = getBoundingClientRectPropertyRefs(helpDropdownMenuToggleButtonNode, { windowResize: true });

  function toggleDropdown() {
    isOpen.value = !isOpen.value;
  }

  function closeDropdown() {
    isOpen.value = false;
  }

  watch(isOpen, () => {
    if (!isOpen.value) {
      helpDropdownMenuToggleButtonNode.value?.blur();
    }
  });
</script>

<style scoped>
  .dropdown-parent-container {
    position: relative;
  }

  ul {
    max-height: v-bind('`${dropdownHeight}px`');
  }
</style>
